module.exports = __webpack_public_path__ + "static/media/slide5.881ced97.gif";